import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfoContent from '../../../components/common/InfoContent';
import { validateTaxId } from '../../../utils/validationClient';

const TaxId = ({ userData, setUserData, store, formErrors, setFormErrors }) => {
  const [infoField, setInfoField] = useState(null);
  const { t } = useTranslation();
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData(prev => ({ ...prev, [name]: value }));
    
    // Validation immédiate
    const isTaxIdOptional = store.tax_id_optional || 
      (store.tax_id_position === 1 && !userData.isGettingInvoiceActivated);
    
    if (value && value.trim() !== '') {
      const isValid = validateTaxId(value, store.codeTaxId, { isOptional: isTaxIdOptional });
      if (!isValid) {
        setFormErrors(prev => ({ 
          ...prev, 
          taxId: t("Le format de la TVA n'est pas valide")
        }));
      } else {
        setFormErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors.taxId;
          return newErrors;
        });
      }
    } else if (!isTaxIdOptional && (!value || value.trim() === '')) {
      setFormErrors(prev => ({ 
        ...prev, 
        taxId: t("L'identifiant fiscal est obligatoire")
      }));
    } else {
      setFormErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.taxId;
        return newErrors;
      });
    }
  };

  const handleShowInfo = (fieldId) => {
    setInfoField(fieldId);
  };

  const handleHideInfo = () => {
    setInfoField(null);
  };

  return (
    <div className="formField">
      <div className={`formControl ${store.codeTaxId ? 'hasInfo' : ''}`}>
        <input
          type="text"
          name="taxId"
          id="taxId"
          value={userData.taxId || ''}
          onChange={handleInputChange}
          placeholder={`${t('Code taxid')} ${store.tax_id_optional ? '' : '*'}`}
          required={!store.tax_id_optional}
          aria-label={t("Code taxid")}
          aria-invalid={formErrors.taxId ? 'true' : 'false'}
          aria-describedby={formErrors.taxId ? 'error-taxId' : undefined}
        />
        {store.codeTaxId && (
          <InfoContent
            id="forCodeTaxId"
            infoField={infoField}
            showInfo={() => handleShowInfo('forCodeTaxId')}
            hideInfo={handleHideInfo}
            context="taxId"
            infoText={
              <p>
                {t('taxId.tooltip').replace('[[format]]',
                  store.codeTaxId === "NIF HU" ? 'XXXXXXXX-X-XX' :
                  store.codeTaxId === "NIF PT" ? '123456789' :
                  'Format standard')}
              </p>
            }
            ariaLabelShow={t("Informations sur l'identifiant fiscal")}
            ariaLabelHide={t("Fermer les informations")}
          />
        )}
      </div>
      {formErrors.taxId && (
        <div className="field-error" id="error-taxId" role="alert">
          <span className="error-icon" aria-hidden="true">⚠️</span>
          <span className="error-message">{formErrors.taxId}</span>
        </div>
      )}
    </div>
  );
};

export default TaxId;